import clsx from "clsx";
import type { FC, MouseEventHandler } from "react";

import { t } from "i18n/i18n";
import { Tooltip } from "mds/components/Tooltip";
import { SquareButton, type SquareButtonKind } from "mds/components/buttons/SquareButton";
import { LoadingDotsIcon } from "mds/icons";

interface JoinGroupButtonProps {
  kind: SquareButtonKind;
  disabled?: boolean;
  isLoading?: boolean;
  isSelected: boolean;
  onChangeGroup: MouseEventHandler<HTMLButtonElement>;
  onConfirm: MouseEventHandler<HTMLButtonElement>;
  index: number;
}

export const JoinGroupButton: FC<JoinGroupButtonProps> = ({
  disabled,
  isLoading,
  isSelected,
  kind,
  onChangeGroup,
  onConfirm,
  index,
}) => {
  return (
    <Tooltip
      content={
        disabled
          ? t("student_self_select_card.tooltip.group_full")
          : isSelected
            ? t("student_self_select_card.tooltip.start_activity")
            : t("student_self_select_card.tooltip.become_member")
      }
    >
      {(tooltipAnchorProps) => (
        <SquareButton
          aria-disabled={disabled}
          className={clsx(isLoading && "cursor-not-allowed")}
          kind={kind}
          size="xs"
          onClick={isLoading ? undefined : isSelected ? onConfirm : onChangeGroup}
          {...tooltipAnchorProps}
        >
          {isLoading ? (
            <LoadingDotsIcon aria-label={t("common.loading")} />
          ) : isSelected ? (
            t("common.confirm_group")
          ) : (
            t("common.join_group", {
              number: index + 1,
            })
          )}
        </SquareButton>
      )}
    </Tooltip>
  );
};
